import { get } from 'lodash';

export const getPaymentType = payment => {
  if (hasToVerifyMicroDeposits(payment)) return 'bank_account';

  return get(payment, 'source.object', null);
};

export const hasPaymentToPublish = (payment, user) => {
  if (hasToVerifyMicroDeposits(payment)) return true;
  if (user.go4Paid) return true;

  return !!payment && !!payment.source && !!payment.source.id && !!payment.loadedSource;
};

export const hasToVerifyMicroDeposits = payment => {
  return !!Object.keys(payment).includes('publicToken') && !!payment.publicToken;
};

export const getErrorMessage = message => {
  return message.replace(/\(.*?\)/g, '').trim();
};

export const showBlockedFailedPaymentPopups = user => {
  if (user.go4Paid) return;

  return user.blockedFailedPaymentAt || user.updatedPaymentMethodAt;
};

export const hasPendingFailedPayment = job => {
  return job.lastPaymentAttemptAt && !get(job, 'payment.paidAt');
};

export const blockedByFailedPayment = user => {
  return user.blockedFailedPaymentAt && !user.failedPaymentBlockOverride && !user.go4Paid;
};

export const pendingUnblockFailedPayment = user => {
  return user.updatedPaymentMethodAt && !user.failedPaymentBlockOverride && !user.go4Paid;
};

// Whether the ACH authorization has been given for the payment method being
// saved. `stripeTerms` is consent captured in this session's mandate modal;
// `mandateAcceptedOn` is consent already on file from a previous session or from
// accepting the updated Terms. Either satisfies saving — without the persisted
// half, a user who consented earlier (e.g. before a micro-deposit wait) comes
// back to a permanently disabled Update Payment button.
export const hasAchMandateConsent = ({ user, stripeTerms } = {}) => {
  return !!stripeTerms || !!(user || {}).mandateAcceptedOn;
};

export const ACH_MANDATE_CONSENT_TEXT =
  'By adding a payment method and listing a job on Go4, you authorize Go4 Ellis, Inc. ("Go4") to initiate one or more debit entries via ACH or card to the account or card you provide, in amounts corresponding to the compensation owed for shifts posted under this listing that are filled and confirmed as worked. This authorization remains in effect until you revoke it or the listing is closed, whichever comes first.';
